import React from "react";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";

export default function CustomDropdown({
    id,
    name,
    value,
    style,
    options,
    onChange,
    onClick,
    onFocus,
    onHide,
    disabled = false,
    placeholder = "Izaberi opciju",
    required = false,
    invalid = false,
    className = "w-full",
    optionLabel = "name",
    filter = true,
    showClear = true,
    filterPlaceholder = "Pretraži...",
    emptyMessage,
    itemTemplate,
    valueTemplate
}) {
    const { t } = useTranslation();

    /* Bez ovoga PrimeReact na prazan spisak ispisuje svoje englesko
       "No available options" — jedini engleski tekst u celoj formi. */
    const porukaPrazno = emptyMessage ?? t('common.nemaOpcija');

    const handleChange = (e) => {
        if (onChange) {
            onChange({
                target: {
                    name: name,
                    value: e.value
                }
            });
        }
    };

    return (
        <Dropdown
            id={id}
            name={name}
            value={value}
            style={style}
            options={options}
            disabled={disabled}
            onClick={onClick}
            onFocus={onFocus}
            onHide={onHide}
            onChange={handleChange}  // koristi naš handler
            placeholder={placeholder}
            required={required}
            className={`${className} ${invalid ? "p-invalid" : ""}`}
            optionLabel={optionLabel}
            filter={filter}
            showClear={showClear}
            filterPlaceholder={filterPlaceholder}
            emptyMessage={porukaPrazno}
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
        />
    );
}